module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h2>Availability</h2>\n\n<div class="form-group">\n  <div id="availability" class="availability-container"></div>\n  <span class="help-block hidden"></span>\n</div>\n';

}
return __p
}